import React, { useState } from "react";

// Mapping your training list to professional icons
const trainingData = [
  { id: "aws", title: "AWS", shortDesc: "Cloud Computing & Infrastructure", image: "https://upload.wikimedia.org/wikipedia/commons/9/93/Amazon_Web_Services_Logo.svg" },
  { id: "comptia", title: "CompTIA Security+", shortDesc: "Cybersecurity Foundations", image: "https://upload.wikimedia.org/wikipedia/commons/b/b1/CompTIA_Logo.svg" },
  { id: "scrum", title: "Scrum Master", shortDesc: "Agile Project Management", image: "https://upload.wikimedia.org/wikipedia/commons/5/5e/Scrum_logo.svg" },
  { id: "ethical-hacking", title: "Ethical Hacking", shortDesc: "Penetration Testing & Security", image: "https://img.icons8.com/color/512/hacking.png" },
  { id: "java", title: "Java Full Stack", shortDesc: "Backend & Frontend Mastery", image: "https://upload.wikimedia.org/wikipedia/en/3/30/Java_programming_language_logo.svg" },
  { id: "python", title: "Python", shortDesc: "Data Science & Automation", image: "https://upload.wikimedia.org/wikipedia/commons/c/c3/Python-logo-notext.svg" },
  { id: "salesforce", title: "Salesforce", shortDesc: "CRM & Cloud Solutions", image: "https://upload.wikimedia.org/wikipedia/commons/f/f9/Salesforce.com_logo.svg" },
  { id: "tableau", title: "Tableau Developer", shortDesc: "Business Intelligence & Data", image: "https://upload.wikimedia.org/wikipedia/commons/4/4b/Tableau_Logo.svg" },
  { id: "sql-dba", title: "SQL DBA", shortDesc: "Database Administration", image: "https://img.icons8.com/color/512/microsoft-sql-server.png" },
  { id: "workday", title: "Workday HCM", shortDesc: "Human Capital Management", image: "https://upload.wikimedia.org/wikipedia/commons/d/d7/Workday_logo.svg" },
  { id: "angular", title: "Angular JS", shortDesc: "Modern Web Development", image: "https://upload.wikimedia.org/wikipedia/commons/c/cf/Angular_full_color_logo.svg" },
  { id: "splunk", title: "Splunk", shortDesc: "Log Analysis & Monitoring", image: "https://img.icons8.com/color/512/splunk.png" },
];

const Courses = () => {
  const [showAll, setShowAll] = useState(false);

  const visibleCourses = showAll ? trainingData : trainingData.slice(0, 6);

  return (
    <section className="py-20 px-4 md:px-24 bg-white">
      <div className="text-center mb-16">
        <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
          🎓 Professional Training
        </h2>
        <div className="h-1.5 w-20 bg-[#a300ff] mx-auto rounded-full"></div>
      </div>

      <div className="grid gap-8 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {visibleCourses.map((course) => (
          <div
            key={course.id}
            className="group bg-white p-8 rounded-[2rem] border border-gray-100 shadow-sm hover:shadow-2xl hover:-translate-y-2 transition-all duration-300"
          >
            <div className="w-20 h-20 mx-auto mb-6 p-4 bg-slate-50 rounded-2xl group-hover:bg-purple-50 transition-colors">
              <img src={course.image} alt={course.title} className="w-full h-full object-contain" />
            </div>
            <h3 className="text-2xl font-bold text-center text-gray-800 mb-2">{course.title}</h3>
            <p className="text-gray-500 text-center text-sm mb-6">{course.shortDesc}</p>
            <div className="text-center">
              <span className="text-[#a300ff] font-bold text-sm uppercase tracking-widest opacity-80">
                Course Available
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-16">
        <button
          onClick={() => setShowAll(!showAll)}
          className="bg-[#a300ff] text-white font-bold py-4 px-12 rounded-2xl shadow-lg hover:scale-105 transition active:scale-95"
        >
          {showAll ? "Show Less" : "View All Training Programs"}
        </button>
      </div>
    </section>
  );
};

export default Courses;